import React from 'react';
import SelectElement from 'epic-diesel-form/src/components/form/SelectElement';
import {Message, Icon} from 'epic-diesel-common';
import {svgs} from 'epic-diesel-common/src/constants';
import {SocialChannel, SocialPlatform, ChannelStatus} from '../../../../../shared/types';
import cx from 'classnames';

//@ts-ignore
import styles from './MainSocialChannelSection.pcss';

interface Props {
    messages: any;
    mainChannelPlatform: string;
    configState: Record<string, any>;
    channels: SocialChannel[];
    trigger: (key: string, value) => void;
    showError: boolean;
}

const CODES = {
    header: 'epic.affiliate.social.channels.mainChannel.header.v2',
    title: 'epic.affiliate.social.channels.mainChannel.title.v2'
};

const MainSocialChannelSection: React.FC<Props> = props => {
    const {mainChannelPlatform, configState, trigger, channels, showError} = props;
    const {disableSocials = {}} = configState || {};
    const renderChannels = [];
    const linkedChannels = channels.reduce((prev, channel, index) => {
        const {channelStatus, violations = []} = channel;

        prev[channel.platform] = {
            index,
            isLinked: channelStatus === ChannelStatus.VALID,
            isStriked: violations.length > 0,
            mainChannel: channel.platform === mainChannelPlatform
        };

        return prev;
    }, {});

    for (const platform in SocialPlatform) {
        if (typeof platform === 'string' && disableSocials[platform.toLowerCase()] !== true) {
            const {mainChannel, isLinked, isStriked} = linkedChannels[platform] || {};

            const classes = cx(styles.item, {
                [styles.selected]: mainChannel
            });

            renderChannels.push(
                <SelectElement
                    disabled={!isLinked || isStriked || mainChannel}
                    key={platform}
                    className={classes}
                    role="presentation"
                    name={platform}
                    value={mainChannel}
                    onChange={(e, name, value) => {
                        trigger('mainChannelPlatform', platform);
                    }}>
                    <Icon
                        icon={svgs[`SOCIAL_${platform.split('_')[0]}`] || svgs.EPIC}
                        className={styles[platform]}
                    />
                </SelectElement>
            );
        }
    }

    return (
        <>
            <h2>
                <Message code={CODES.header} />
                {' *'}
            </h2>
            <p>
                <Message code={CODES.title} />
            </p>

            <div className={styles.group}>{renderChannels}</div>

            {showError && !mainChannelPlatform && (
                <div className={styles.errorMessage}>
                    <Message code={'errors.com.epicgames.validation.required_field.v2'} />
                </div>
            )}
        </>
    );
};

export default MainSocialChannelSection;
